// src/context/LanguageContext.jsx
import React, { createContext, useState, useContext } from 'react';
import { translations } from '../api/athletesApi';

const LanguageContext = createContext();

// Available languages
const AVAILABLE_LANGUAGES = ['it', 'en', 'de'];

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('it'); // Default to Italian

  const t = (key) => {
    const translation = translations[key];
    if (translation && typeof translation === 'object') {
      return translation[language] || translation['it'] || key;
    }
    return key;
  };

  const cycleLanguage = () => {
    const currentIndex = AVAILABLE_LANGUAGES.indexOf(language);
    const nextIndex = (currentIndex + 1) % AVAILABLE_LANGUAGES.length;
    setLanguage(AVAILABLE_LANGUAGES[nextIndex]);
  };

  const availableLanguages = AVAILABLE_LANGUAGES;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, cycleLanguage, availableLanguages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
